angular.module('lf.desktop')

.directive('cardFormCardIcons', function () {
  return function (scope, el, attrs) {
    el.closest('form')
      .find('.form__field_number .field__input')
      .append(el);
  }
});
